/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { translateGetAiTranslateLanguages } from "../../funcs/translateGetAiTranslateLanguages.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$translateGetAiTranslateLanguages: ToolDefinition = {
  name: "translate-get-ai-translate-languages",
  description: `AI翻译配置

获取AI智能翻译服务支持的完整语言列表、翻译风格选项、上下文场景选项以及性能指标信息。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  tool: async (client, ctx) => {
    const [result] = await translateGetAiTranslateLanguages(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
